export default "__VITE_ASSET__DZ4m9YVy__"